import AuthSessionStatus from '@/components/AuthSessionStatus'
import AuthValidationErrors from '@/components/AuthValidationErrors'
import { Hero } from '@/components/Hero'
import { useAuth } from '@/hooks/auth'
import { ArrowRightIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Container,
  Flex,
  Input,
  Link,
  Spinner,
  Stack,
} from '@chakra-ui/react'
import { FormEvent, useState } from 'react'

const ForgotPassword = () => {
  const { forgotPassword } = useAuth({
    middleware: 'guest',
    redirectIfAuthenticated: false,
  })

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState([])
  const [status, setStatus] = useState(null)

  const submitForm = (event: FormEvent) => {
    event.preventDefault()
    forgotPassword({ email, setErrors, setStatus })
  }

  return (
    <>
      <Hero heading='Forgot Your Password?' />
      <Container py='20' maxWidth='2xl'>
        <Stack spacing={12}>
          {!status && (
            <Box textAlign='center'>
              Forgot your password? No problem. Just let us know your email
              address and we will email you a password reset link that will
              allow you to choose a new one.
            </Box>
          )}

          {/* Session Status */}
          <AuthSessionStatus status={status} />

          {/* Validation Errors */}
          <AuthValidationErrors errors={errors} />

          {!status && (
            <form onSubmit={submitForm}>
              {/* Email Address */}
              <Flex>
                <Input
                  aria-label='email'
                  id='email'
                  type='email'
                  name='email'
                  value={email}
                  className='block mt-1 w-full'
                  onChange={event => setEmail(event.target.value)}
                  placeholder='Email Address'
                  required
                  autoFocus
                />
                <Button ml={2} alignSelf='end' colorScheme='red' type='submit'>
                  {status === 'Sending…' ? (
                    <Spinner size='sm' />
                  ) : (
                    <ArrowRightIcon />
                  )}
                </Button>
              </Flex>
            </form>
          )}

          {status && status !== 'Sending…' && (
            <Box>
              <Box textAlign='center'>
                Didn’t work?{' '}
                <Link
                  textDecoration='underline'
                  mx='auto'
                  onClick={() => setStatus(null)}>
                  Send the email again.
                </Link>
              </Box>
            </Box>
          )}
        </Stack>
      </Container>
    </>
  )
}

export default ForgotPassword
